/*
 页面打开关闭的埋点，写新路由时，需要在此处添加新的对象， 并在 https://eas-test.gyasset.com/monitor/app/crm-weixin-dev/manage/origin-events 中新建事件 *测试环境中不用新建，在正式环境建
 1. eventId格式： 打开页面 open${eventId} ; 关闭页面 close${eventId}
 2. title格式：打开${title}页, 携带参数from.path query； 关闭${title}页
 */

export const webTracingConfig = {
  '/findPasswordOne': {
    title: '找回密码-验证身份信息',
    eventId: 'FindPasswordOne'
  },
  '/findPasswordTwo': {
    title: '找回密码-验证手机号码',
    eventId: 'FindPasswordTwo'
  },
  '/findPasswordThree': {
    title: '找回密码-设置新密码',
    eventId: 'FindPasswordThree'
  },
  '/findPasswordFour': {
    title: '找回密码-找回密码成功',
    eventId: 'FindPasswordFour'
  },
  '/findPasswordAgreement': {
    title: '找回密码时高毅注册协议',
    eventId: 'FindPasswordAgreement'
  },
  '/myPropertiesTab': {
    title: '我的资产',
    eventId: 'MyPropertiesTab'
  },
  '/reports': {
    title: '公告与报告',
    eventId: 'Reports'
  },
  '/reportsNoBack': {
    title: '公告报告',
    eventId: 'ReportsNoBack'
  },
  '/reportsNoBackDetail': {
    title: '公告报告',
    eventId: 'ReportsNoBackDetail'
  },
  '/personFillCustomerInfo': {
    title: '高毅资产合格投资者确认书-个人',
    eventId: 'PersonFillCustomerInfo'
  },
  '/institutionFillAgentInfo': {
    title: '高毅资产合格投资者确认书-机构',
    eventId: 'InstitutionFillAgentInfo'
  },
  '/institutionFillInfo': {
    title: '高毅资产合格投资者确认书-机构信息填写',
    eventId: 'InstitutionFillInfo'
  },
  '/potentialConfirmPage': {
    title: '高毅资产合格投资者确认书-机构-承诺书',
    eventId: 'PotentialConfirmPage'
  },
  '/submitSuccess': {
    title: '高毅资产合格投资者确认书-机构-确认成功',
    eventId: 'SubmitSuccess'
  },
  '/managerRiskQuestion': {
    title: '沙龙问卷-个人信息填写',
    eventId: 'ManagerRiskQuestion'
  },
  '/managerRiskQuestion/suitability': {
    title: '沙龙问卷-适当性问卷1',
    eventId: 'ManagerRiskQuestionSuitability'
  },
  '/managerRiskQuestion/ofType': {
    title: '沙龙问卷-适当性问卷2',
    eventId: 'ManagerRiskQuestionOfType'
  },
  '/managerRiskQuestion/result': {
    title: '沙龙问卷-测评结果',   
    eventId: 'ManagerRiskQuestionResult'
  },
  '/managerRiskQuestion/resultComplete': {
    title: '沙龙问卷-测评结果',  // 与上面为同一页面
    eventId: 'ManagerRiskQuestionResultComplete'
  },
  '/pdf': {
    title: '查看pdf',
    eventId: 'Pdf'
  },
  '/pdfWeb': {
    title: '产品信息-公告报告查看pdf',
    eventId: 'PdfWeb'
  },
  '/allReport': {
    title: '公告报告查看pdf',
    eventId: 'AllReport'
  },
  '/shareConfirmPdf': {
    title: '历史预约查看pdf',
    eventId: 'ShareConfirmPdf'
  },
  '/ePdf': {
    title: '查看合同',
    eventId: 'EPdf'
  },
  '/fundIntroductionWeb': {
    title: '推介材料PC端',
    eventId: 'FundIntroductionWeb'
  },
  '/fundIntroduction': {
    title: '推介材料手机端',
    eventId: 'FundIntroduction'
  },
  '/login': {
    title: '登录',
    eventId: 'Login'
  },
  '/wechat': {
    title: '微信',
    eventId: 'Wechat'
  },
  '/wechat/redirect': {
    title: '微信重定向',
    eventId: 'WechatRedirect'
  },
  '/wechat/confirm': {
    title: '登录并绑定微信账号',
    eventId: 'WechatConfirm'
  },
  '/agreementPage': {
    title: '阅读协议',
    eventId: 'AgreementPage'
  },
  '/agreementDialogPage': {
    title: '高毅资产服务平台使用协议提示框',
    eventId: 'AgreementDialogPage'
  },
  '/login/bytoken': {
    title: '登录重定向',
    eventId: 'LoginBytoken'
  },
  '/riskEvaluation': {
    title: '风险评估问卷',
    eventId: 'RiskEvaluation'
  },
  '/fillInfo': {
    title: '购买前填写个人信息',
    eventId: 'FillInfo'
  },
  '/mobileRiskRemind': {
    title: '风险揭示书',
    eventId: 'MobileRiskRemind'
  },
  '/mobileInvestorResult': {
    title: '投资者资质确认结果页面',
    eventId: 'MobileInvestorResult'
  },
  '/mobileQuestionnaire': {
    title: '风险属性评估问卷',
    eventId: 'MobileQuestionnaire'
  },
  '/questionnaireResult': {
    title: '风险属性评估问卷结果页面',
    eventId: 'QuestionnaireResult'
  },
  '/mobileRiskInvestor': {
    title: '投资者资质确认',
    eventId: 'MobileRiskInvestor'
  },
  '/propertyDetailsMobile': {
    title: '产品详情手机端',
    eventId: 'PropertyDetailsMobile'
  },
  '/productDetail': {
    title: '产品详情',
    eventId: 'ProductDetail'
  },
  '/addFund': {
    title: '追加申购',
    eventId: 'AddFund'
  },
  '/purchaseStatusWait': {
    title: '提交申购申请',
    eventId: 'PurchaseStatusWait'
  },
  '/register': {
    title: '注册',
    eventId: 'Register'
  },
  '/registMobileOne': {
    title: '注册手机端1',
    eventId: 'RegistMobileOne'
  },
  '/registMobileTwo': {
    title: '注册手机端2',
    eventId: 'RegistMobileTwo'
  },
  '/registMobileThree': {
    title: '注册手机端3',
    eventId: 'RegistMobileThree'
  },
  '/historyTab': {
    title: '交易记录',
    eventId: 'HistoryTab'
  },
  '/historyTabNoBack': {
    title: '交易记录',
    eventId: 'HistoryTabNoBack'
  },
  '/myProperties': {
    title: '我的资产',
    eventId: 'MyProperties'
  },
  '/myAttentionTab': {
    title: '产品信息',
    eventId: 'MyAttentionTab'
  },
  '/personalData': {
    title: '个人资料',
    eventId: 'PersonalData'
  },
  '/personalInfo': {
    title: '个人资料',
    eventId: 'PersonalInfo'
  },
  '/passwordAll': {
    title: '安全设置',
    eventId: 'PasswordAll'
  },
  '/changePasswordOne': {
    title: '修改密码1',
    eventId: 'ChangePasswordOne'
  },
  '/changePasswordTwo': {
    title: '修改密码2',
    eventId: 'ChangePasswordTwo'
  },
  '/changeEmail': {
    title: '修改邮箱',
    eventId: 'ChangeEmail'
  },
  '/changeAddress': {
    title: '修改联系地址',
    eventId: 'ChangeAddress'
  },
  '/propertyDetails': {
    title: '资产详情',
    eventId: 'PropertyDetails'
  },
  '/historyDetails': {
    title: '交易记录明细',
    eventId: 'HistoryDetails'
  },
  '/on-passage-application': {
    title: '我的预约',
    eventId: 'OnPassageApplication'
  },
  '/history-application': {
    title: '历史预约',
    eventId: 'HistoryApplication'
  },
  '/application-detail_web': {
    title: '预约详情PC端',
    eventId: 'ApplicationDetailWeb'
  },
  '/application-detail': {
    title: '预约详情手机端',
    eventId: 'ApplicationDetail'
  },
  '/waitingForAsync': {
    title: '查看IQ数据是否同步',
    eventId: 'WaitingForAsync'
  },
  '/historyAsset': {
    title: '历史查询',
    eventId: 'HistoryAsset'
  },
  '/historyNav': {
    title: '历史净值',
    eventId: 'HistoryNav'
  },
  '/report': {
    title: '公告报告',
    eventId: 'report'
  },
  '/redeemFillInfo': {
    title: '赎回-填写预约信息',
    eventId: 'RedeemFillInfo'
  },
  '/redeemVerify': {
    title: '赎回-验证身份信息',
    eventId: 'RedeemVerify'
  },
  '/redeemComplete': {
    title: '赎回-提交预约',
    eventId: 'RedeemComplete'
  },
  '/subscribeConfirmFillInfo': {
    title: '认购-确认个人信息',
    eventId: 'SubscribeConfirmFillInfo'
  },
  '/subscribeFillInfo': {
    title: '认购-填写预约信息',
    eventId: 'SubscribeFillInfo'
  },
  '/subscribeVerify': {
    title: '认购-验证身份信息',
    eventId: 'SubscribeVerify'
  },
  '/subscribeComplete': {
    title: '认购-提交预约',
    eventId: 'SubscribeComplete'
  },
  '/cancellationVerify': {
    title: '撤销预约-验证身份信息',
    eventId: 'CancellationVerify'
  },
  '/cancellationComplete': {
    title: '撤销预约-提交撤销申请',
    eventId: 'CancellationComplete'
  },
  '/amendVerify': {
    title: '修改预约-验证身份信息',
    eventId: 'AmendVerify'
  },
  '/amendFillInfo': {
    title: '修改预约-修改预约信息',
    eventId: 'AmendFillInfo'
  },
  '/amendComplete': {
    title: '修改预约-提交修改申请',
    eventId: 'AmendComplete'
  },
  '/purchaseConfirmInfoWeb': {
    title: '申购-确认个人信息PC端',
    eventId: 'PurchaseConfirmInfoWeb'
  },
  '/purchaseConfirmInfo': {
    title: '申购-确认个人信息',
    eventId: 'PurchaseConfirmInfo'
  },
  '/purchaseFillInfo': {
    title: '申购-填写预约信息',
    eventId: 'PurchaseFillInfo'
  },
  '/purchaseFillInfoWeb': {
    title: '申购-填写预约信息',
    eventId: 'PurchaseFillInfoWeb'
  },
  '/purchaseVerify': {
    title: '申购-验证身份信息',
    eventId: 'PurchaseVerify'
  },
  '/purchaseComplete': {
    title: '申购-提交预约',
    eventId: 'PurchaseComplete'
  },
  '/purchaseCompleteWeb': {
    title: '申购-提交预约PC端',
    eventId: 'purchaseCompleteWeb'
  },
  '/appendConfirmInfo': {
    title: '追加-确认个人信息',
    eventId: 'AppendConfirmInfo'
  },
  '/appendConfirmInfoWeb': {
    title: '追加-确认个人信息PC端',
    eventId: 'AppendConfirmInfoWeb'
  },
  '/appendFillInfo': {
    title: '追加-填写预约信息',
    eventId: 'AppendFillInfo'
  },
  '/appendVerify': {
    title: '追加-验证身份信息',
    eventId: 'AppendVerify'
  },
  '/appendComplete': {
    title: '追加-提交预约',
    eventId: 'AppendComplete'
  },
  '/editPassword': {
    title: '修改密码',
    eventId: 'EditPassword'
  },
  '/quicklyRegister': {
    title: '一键注册',
    eventId: 'QuicklyRegister'
  },
  '/myAgreement': {
    title: '高毅资产服务平台使用协议',
    eventId: 'MyAgreement'
  },
  '/myLatestFundOrReportMessage': {
    title: '产品资讯与报告',
    eventId: 'MyLatestFundOrReportMessage'
  },
  '/myAllReportMessage': {
    title: '公告与报告',
    eventId: 'MyAllReportMessage'
  },
  '/myAllReportMsgReportsDetail': {
    title: '公告报告',
    eventId: 'MyAllReportMsgReportsDetail'
  },
  '/myAllFundAndReportMessage': {
    title: '产品资讯',
    eventId: 'MyAllFundAndReportMessage'
  },
  '/myAllFundAndReportMessageNoBack': {
    title: '产品资讯',
    eventId: 'MyAllFundAndReportMessageNoBack'
  },
  '/latestFundAndReportMsgPdfWeb': {
    title: '产品资讯与报告pdf查看',
    eventId: 'LatestFundAndReportMsgPdfWeb'
  },
  '/fundAndReportMsgPdfWeb': {
    title: '产品资讯pdf查看',
    eventId: 'FundAndReportMsgPdfWeb'
  },
  '/fundAndReportMsgPdfWeb2': {
    title: '公告报告pdf查看',
    eventId: 'FundAndReportMsgPdfWeb2'
  },
  '/fundAndReportMsgPdfWeb3': {
    title: '产品资讯pdf查看',
    eventId: 'FundAndReportMsgPdfWeb3'
  },
  '/fundAndReportMsgPdfWeb4': {
    title: '产品资讯pdf查看',
    eventId: 'FundAndReportMsgPdfWeb4'
  },
  '/fundAndReportMsgPdfWeb5': {
    title: '产品信息-产品资讯pdf查看',
    eventId: 'FundAndReportMsgPdfWeb5'
  },
  '/directImageVideoMp3View': {
    title: '分享音视频查看',
    eventId: 'DirectImageVideoMp3View'
  },
  '/wechatFollowed': {
    title: '微信引导关注',
    eventId: 'WechatFollowed'
  },
  '/directFundAndReportMsgPdfWeb': {
    title: '分享pdf查看',
    eventId: 'DirectFundAndReportMsgPdfWeb'
  },
  '/imageVideoMp3View': {
    title: '查看音视频',
    eventId: 'imageVideoMp3View'
  },
  '/imageVideoMp3View2': {
    title: '查看音视频',
    eventId: 'imageVideoMp3View2'
  },
  '/imageVideoMp3View3': {
    title: '查看音视频',
    eventId: 'imageVideoMp3View3'
  },
  '/imageVideoMp3View4': {
    title: '查看音视频',
    eventId: 'imageVideoMp3View4'
  },
  '/messageList': {
    title: '公告、报告、产品资讯列表页',
    eventId: 'messageList'
  },
  '/historyList': {
    title: '公告、报告、产品资讯历史列表页',
    eventId: 'historyList'
  },
  '/historyDetail': {
    title: '公告、报告详情页',
    eventId: 'historyDetail'
  },
  '/noticeList': {
    title: 'pc端我的资产-公告列表页',
    eventId: 'noticeList'
  },
  '/noticePdf': {
    title: 'pc端我的资产-公告列表-查看音视频页',
    eventId: 'noticePdf'
  },
  '/noticeHistoryPdf': {
    title: 'pc端公告-查看音视频页',
    eventId: 'noticeHistoryPdf'
  },
  '/reportList': {
    title: 'pc端我的资产-报告列表页',
    eventId: 'reportList'
  },
  '/reportPdf': {
    title: 'pc端我的资产-报告列表-查看音视频页',
    eventId: 'reportPdf'
  },
  '/reportHistoryPdf': {
    title: 'pc端报告-查看音视频页',
    eventId: 'reportHistoryPdf'
  },
  '/productInformationList': {
    title: 'pc端我的资产-产品资讯列表页',
    eventId: 'productInformationList'
  },
  '/audioAndVideo': {
    title: 'pc端我的资产-产品资讯列表-查看音视频页',
    eventId: 'audioAndVideo'
  },
  '/audioAndVideoHistory': {
    title: 'pc端产品资讯-查看音视频页',
    eventId: 'audioAndVideoHistory'
  },
  '/productInformationPdf': {
    title: 'pc端我的资产-产品资讯列表-查看pdf页',
    eventId: 'productInformationPdf'
  },
  '/productInformationHistoryPdf': {
    title: 'pc端产品资讯-查看pdf页',
    eventId: 'productInformationHistoryPdf'
  },
  '/noticeHistoryList': {
    title: 'pc端公告页',
    eventId: 'noticeHistoryList'
  },
  '/reportHistoryList': {
    title: 'pc端报告页',
    eventId: 'reportHistoryList'
  },
  '/productInformationHistoryList': {
    title: 'pc端产品资讯页',
    eventId: 'productInformationHistoryList'
  },
  '/identityVerification': {
    title: '申购-验证身份信息',
    eventId: 'purchaseIdentityVerification'
  },
  '/faceVerifyOne': {
    title: '人脸识别',
    eventId: 'faceVerifyOne'
  },
  '/bankVerifyOne': {
    title: '银行卡认证',
    eventId: 'bankVerifyOne'
  },
  '/bankVerifyTwo': {
    title: '银行卡认证-验证身份信息',
    eventId: 'bankVerifyTwo'
  },
  '/setSignature': {
    title: '设置签名图案和密码',
    eventId: 'setSignature'
  },
  '/promisePdf': {
    title: '签署电子签名承诺函',
    eventId: 'promisePdf'
  },
  '/forgetPwd': {
    title: '重新设置签署密码',
    eventId: 'forgetPwd'
  },
  '/uploadFile': {
    title: '上传资质证明文件',
    eventId: 'uploadFile'
  },
  '/fileList': {
    title: '签署适当性文件',
    eventId: 'fileList'
  },
  '/pdfRecord': {
    title: '阅读合同',
    eventId: 'pdfRecord'
  },
  '/makePayment': {
    title: '电子合同——打款',
    eventId: 'makePayment'
  },
  '/returnVisit': {
    title: '电子合同——回访确定',
    eventId: 'returnVisit'
  },
}